export const environment = {
  production: true,
  baseUrl: 'https://api.trial.mstrance.digital-nirvana.com/',
  wsEndpoint: 'wss://79cdcqkgn8.execute-api.us-east-1.amazonaws.com/trial',
  environmentType: 'trial',
};
